module.exports = __webpack_public_path__ + "static/travel2020-78ee6d7cdfae7dfed8159d458d79e684.jpg";